
import React from 'react';
import { TeamForm } from '../form/TeamForm';
import { Match } from '../types/head-to-head';

interface TeamFormSectionProps {
  homeTeam: string;
  awayTeam: string;
  matches: Match[];
  selectedMatchIndex: number | null;
  setSelectedMatchIndex: (index: number | null) => void;
}

const TeamFormSection: React.FC<TeamFormSectionProps> = ({
  homeTeam,
  awayTeam,
  matches,
  selectedMatchIndex,
  setSelectedMatchIndex
}) => {
  const getTeamResults = (teamName: string) => {
    // Filter only head-to-head matches between these teams
    const h2hMatches = matches.filter(match => 
      (match.HomeTeam === homeTeam && match.AwayTeam === awayTeam) || 
      (match.HomeTeam === awayTeam && match.AwayTeam === homeTeam)
    );

    // Sort matches by date (oldest first)
    const sortedMatches = [...h2hMatches].sort((a, b) => {
      // Use string comparison to preserve original format
      // For oldest first, we use a to b comparison
      return a.Date.localeCompare(b.Date);
    });

    return sortedMatches.map(match => {
      const isTeamHome = match.HomeTeam === teamName;
      const result = match.FTR;
      if (isTeamHome) {
        if (result === 'H') return 'W';
        if (result === 'A') return 'L';
        return 'D';
      } else {
        if (result === 'A') return 'W';
        if (result === 'H') return 'L';
        return 'D';
      }
    });
  };

  const getResultColor = (result: string) => {
    switch (result) {
      case 'W':
        return 'bg-green-500 text-white';
      case 'L':
        return 'bg-red-500 text-white';
      case 'D':
        return 'bg-gray-400 text-white';
      default:
        return 'bg-gray-200';
    }
  };

  // Calculate form stats for both teams based on head-to-head matches
  const homeTeamForm = getTeamResults(homeTeam);
  const awayTeamForm = getTeamResults(awayTeam);

  // Calculate form stats
  const calculateFormStats = (results: string[]) => {
    return {
      wins: results.filter(r => r === 'W').length,
      draws: results.filter(r => r === 'D').length,
      losses: results.filter(r => r === 'L').length
    };
  };

  const homeTeamStats = calculateFormStats(homeTeamForm);
  const awayTeamStats = calculateFormStats(awayTeamForm);

  console.log('Head to head stats - Home team:', homeTeamStats);
  console.log('Head to head stats - Away team:', awayTeamStats);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-4">
      <div>
        <h3 className="text-sm font-medium mb-2"></h3>
        <TeamForm 
          teamName={homeTeam} 
          matches={matches} 
          getTeamResults={getTeamResults} 
          getResultColor={getResultColor} 
          onMatchSelect={() => {}} 
          selectedMatchIndex={null} 
        />
      </div>
      <div>
        <h3 className="text-sm font-medium mb-2"></h3>
        <TeamForm 
          teamName={awayTeam} 
          matches={matches} 
          getTeamResults={getTeamResults} 
          getResultColor={getResultColor} 
          onMatchSelect={() => {}} 
          selectedMatchIndex={null} 
        />
      </div>
    </div>
  );
};

export default TeamFormSection;
